<script>
import { getSlugLink } from '@/composables/slugLink';

export default {
  methods: {
    getSlugLink(item, productsUrl) {
      return getSlugLink(item, productsUrl, this.$fischer);
    },
  },
};
</script>
